// extracted by mini-css-extract-plugin
module.exports = {"messageBubble":"MessageBubble_messageBubble__3mu5s","left":"MessageBubble_left__3bb3J","right":"MessageBubble_right__3S8N8","messageCaption":"MessageBubble_messageCaption__hxd6_"};